import qs from 'querystring';
import BaseClient from './baseClient';

class RecommendConceptsClient extends BaseClient {
  async searchConcepts(
    searchTerms: string,
    searchableOnly = true,
  ): Promise<RecommendConceptQueryResponse> {
    const params = {
      language: 'zh-hans',
      searchTerms,
    };

    const where = searchableOnly ? 'where=(searchable==true)&' : '';
    const res = await this.fetch(
      `/proxy/recommend/concepts/v1?${where}` + qs.encode(params),
    );
    return res;
  }
  async searchAllConcepts(
    searchTerms: string,
  ): Promise<RecommendConceptQueryResponse> {
    const params = {
      language: 'zh-hans',
      searchTerms,
    };
    const res = await this.fetch(
      '/proxy/recommend/concepts/v1?' + qs.encode(params),
    );
    return res;
  }
  async getConceptById(id: string): Promise<RecommendConcept> {
    const res = await this.fetch(
      `/proxy/recommend/concepts/v1/${id}?language=zh-Hans`,
    );
    return res;
  }
  async getConceptsByWhereCause(
    whereCause: string,
  ): Promise<RecommendConceptQueryResponse> {
    const params = {
      language: 'zh-hans',
      sort: 'modificationDateDesc',
    };
    const res = await this.fetch(
      `/proxy/recommend/concepts/v1?where=(${whereCause})&` + qs.encode(params),
    );
    return res;
  }
  async next(page: string): Promise<RecommendConceptQueryResponse> {
    const res = await this.fetch(`/proxy${page}`);
    return res;
  }
}

export default new RecommendConceptsClient();
